module.exports = __webpack_public_path__ + "img/ChallengeTitle.28c2d04f.png";